import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BasicPrinter icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BasicPrinter } from '@sravni/design-system-icons'
 *
 * <BasicPrinter />
 * ```
 */
var BasicPrinter = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BasicPrinter", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.714 7.857v-5h8.572v5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.714 14.286H4.286a1.429 1.429 0 0 1-1.429-1.429V9.286a1.429 1.429 0 0 1 1.429-1.429h11.428a1.428 1.428 0 0 1 1.429 1.429v3.571a1.429 1.429 0 0 1-1.429 1.429h-1.428", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.286 11.429H5.714v5.714h8.572v-5.714Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BasicPrinter };
//# sourceMappingURL=BasicPrinter.js.map
